import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { OAuthService } from '../../../core/services/oauth.service';

@Component({
  selector: 'app-oauth-callback',
  standalone: true,
  template: `
    <div class="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center">
      <div class="text-center">
        <svg class="animate-spin h-10 w-10 text-blue-600 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-gray-600 font-medium">{{ message }}</p>
      </div>
    </div>
  `
})
export class OAuthCallbackComponent implements OnInit {
  message = 'Completing Google sign-in...';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private oauthService: OAuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const error = params['error'];

      if (error || !code) {
        this.router.navigate(['/login'], { queryParams: { error: 'google_cancelled' } });
        return;
      }

      const redirectUri = this.oauthService.getRedirectUri();
      this.authenticationService.googleOAuthLogin(code, redirectUri).subscribe({
        next: (response) => {
          if (response.success) {
            this.router.navigate(['/home']);
          } else {
            this.message = 'Sign-in failed. Redirecting...';
            this.router.navigate(['/login'], { queryParams: { error: 'google_failed' } });
          }
        },
        error: () => {
          this.message = 'Sign-in failed. Redirecting...';
          this.router.navigate(['/login'], { queryParams: { error: 'google_failed' } });
        }
      });
    });
  }
}
